"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = connectAsync;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shallowequal = _interopRequireDefault(require("shallowequal"));

var _reduce = require("./reduce");

var _utils = require("./utils");

var _config = _interopRequireDefault(require("./config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function connectAsync(_ref) {
  var loadDataAsProps = _ref.loadDataAsProps,
      localStateChangeLimiter = _ref.stateChangeLimiter,
      localStateChangeComparator = _ref.stateChangeComparator;
  var ssrEnabled = loadDataAsProps.ssr;

  function buildState(_ref2) {
    var store = _ref2.store,
        ownProps = _ref2.ownProps;
    var propFuncs = loadDataAsProps({
      store: store,
      ownProps: ownProps
    });
    var propResultMap;

    if ((0, _utils.isServer)() && !ssrEnabled) {
      propResultMap = (0, _utils.mapValues)(propFuncs, function () {
        return {
          status: 'loading'
        };
      });
    } else {
      propResultMap = (0, _utils.mapValues)(propFuncs, function (value) {
        return value({
          isServer: (0, _utils.isServer)()
        });
      });
    }

    var promise = (0, _reduce.reducePromise)(propResultMap);
    /*
     * The promise is only used during SSR. During the normal render cycle, it is not as important,
     * as everything is driven by state changes. If the promises are ignored, it could lead to an
     * unhandledrejection event, so we catch here to avoid that.
    */

    (0, _utils.handlePromiseRejection)(promise);
    return {
      data: (0, _reduce.reduceData)(propResultMap),
      status: (0, _reduce.reduceStatus)(propResultMap),
      errors: (0, _reduce.reduceErrors)(propResultMap)
    };
  }

  return function wrapWithConnectAsync(WrappedComponent) {
    var ConnectAsync =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(ConnectAsync, _React$Component);

      function ConnectAsync(props) {
        var _this;

        _classCallCheck(this, ConnectAsync);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(ConnectAsync).call(this, props));

        var reduxStore = props.reduxStore,
            restOfProps = _objectWithoutProperties(props, ["reduxStore"]);

        _this.state = buildState({
          store: reduxStore,
          ownProps: restOfProps
        });
        _this.setStateIfNecessary = _this.setStateIfNecessary.bind(_assertThisInitialized(_this));
        _this.onReduxStateChange = _this.onReduxStateChange.bind(_assertThisInitialized(_this));
        _this.isLoading = _this.isLoading.bind(_assertThisInitialized(_this));
        _this.loadedWithErrors = _this.loadedWithErrors.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(ConnectAsync, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.mounted = true;
          var store = this.props.reduxStore;
          var globalStateChangeLimiter = _config.default.stateChangeLimiter;
          var stateChangeLimiter = localStateChangeLimiter || globalStateChangeLimiter;
          var onReduxStateChangeLimited = stateChangeLimiter(this.onReduxStateChange);
          this.unsubscribe = store.subscribe(function () {
            return _this2.mounted && onReduxStateChangeLimited();
          });
        } // eslint-disable-next-line camelcase

      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          var _this$props = this.props,
              reduxStore = _this$props.reduxStore,
              restOfProps = _objectWithoutProperties(_this$props, ["reduxStore"]);

          var nextReduxStore = nextProps.reduxStore,
              nextRestOfProps = _objectWithoutProperties(nextProps, ["reduxStore"]);

          if (!(0, _shallowequal.default)(restOfProps, nextRestOfProps)) {
            this.setStateIfNecessary(buildState({
              store: nextReduxStore,
              ownProps: nextRestOfProps
            }));
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.mounted = false;
          this.unsubscribe();
        }
      }, {
        key: "onReduxStateChange",
        value: function onReduxStateChange() {
          var _this$props2 = this.props,
              reduxStore = _this$props2.reduxStore,
              restOfProps = _objectWithoutProperties(_this$props2, ["reduxStore"]);

          this.setStateIfNecessary(buildState({
            store: reduxStore,
            ownProps: restOfProps
          }));
        }
      }, {
        key: "setStateIfNecessary",
        value: function setStateIfNecessary(newState) {
          var _this$state = this.state,
              data = _this$state.data,
              status = _this$state.status,
              errors = _this$state.errors;
          var globalStateChangeComparator = _config.default.stateChangeComparator;
          var stateChangeComparator = localStateChangeComparator || globalStateChangeComparator;
          var dataIsEqual = stateChangeComparator(data, newState.data);
          var statusIsEqual = stateChangeComparator(status, newState.status);
          var errorsAreEqual = stateChangeComparator(errors, newState.errors);

          if (!dataIsEqual || !statusIsEqual || !errorsAreEqual) {
            this.setState(newState);
          }
        }
      }, {
        key: "isLoading",
        value: function isLoading(propsOfInterest) {
          var loadStatusMap = this.state.status;
          var statusesOfInterest = Object.values(propsOfInterest ? (0, _utils.pick)(loadStatusMap, propsOfInterest) : loadStatusMap);
          return statusesOfInterest.some(function (status) {
            return status === 'loading';
          });
        }
      }, {
        key: "loadedWithErrors",
        value: function loadedWithErrors(propsOfInterest) {
          var loadErrorMap = this.state.errors;
          var errorsOfInterest = Object.values(propsOfInterest ? (0, _utils.pick)(loadErrorMap, propsOfInterest) : loadErrorMap);
          return errorsOfInterest.some(function (error) {
            return error;
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this$state2 = this.state,
              data = _this$state2.data,
              status = _this$state2.status,
              errors = _this$state2.errors;

          var _this$props3 = this.props,
              reduxStore = _this$props3.reduxStore,
              restOfProps = _objectWithoutProperties(_this$props3, ["reduxStore"]);
          /* eslint-disable react/jsx-props-no-spreading */


          return _react.default.createElement(WrappedComponent, _extends({}, data, restOfProps, {
            loadStatus: status,
            isLoading: this.isLoading,
            loadErrors: errors,
            loadedWithErrors: this.loadedWithErrors
          }));
        }
      }]);

      return ConnectAsync;
    }(_react.default.Component);

    ConnectAsync.propTypes = {
      reduxStore: _propTypes.default.shape({
        subscribe: _propTypes.default.func.isRequired,
        dispatch: _propTypes.default.func.isRequired,
        getState: _propTypes.default.func.isRequired
      }).isRequired
    };
    (0, _hoistNonReactStatics.default)(ConnectAsync, WrappedComponent);
    ConnectAsync.loadDataAsProps = loadDataAsProps;
    ConnectAsync.displayName = "connectAsync(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");

    function ReduxConsumerWrapper(props) {
      return _react.default.createElement(_reactRedux.ReactReduxContext.Consumer, null, function (_ref3) {
        var store = _ref3.store;
        return _react.default.createElement(ConnectAsync, _extends({}, props, {
          reduxStore: store
        }));
      });
    }

    (0, _hoistNonReactStatics.default)(ReduxConsumerWrapper, ConnectAsync);
    ReduxConsumerWrapper.displayName = "ReduxConsumerWrapper(".concat(ConnectAsync.displayName, ")");
    return ReduxConsumerWrapper;
  };
}